namespace RecordShield.Membership.Pages {
    export interface SerialKeyResponse extends Serenity.SaveResponse {
        SerialKey?: string;
    }
}
